import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pay-info-confirm" }
const _hoisted_2 = { style: {"margin-top":"10px"} }
const _hoisted_3 = {
  style: {"padding-bottom":"0","padding-right":"0"},
  class: "xrk-dialog__footer"
}

import { ref, withDefaults, computed } from 'vue';

import {
  BaseButton,
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  createDialog,
  BaseDescriptions,
  BaseDescriptionsItem
} from 'xrk-components';
import { formatter } from '@/utils';

import { confirmPageList } from '../data-source/apis';
import {
  indexCol,
  orderNoCol,
  projectNameCol,
  orderTimeCol,
  orderTypeCol,
  payTypeCol,
  payPassagewayCol,
  orderPriceCol,
  yjkcPriceCol,
  yjzfPriceCol
} from '../fields/columns';
import { orderNoSearch, projectNameSearch } from '../fields/searchs';
import PayInfoConfirmNext from './pay-info-confirm-next.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'pay-info-confirm',
  props: {
    done: { default: () => ({}) },
    payInfo: { default: null },
    taxType: {}
  },
  setup(__props: any) {

const props = __props;
const taxType = computed(() => {
  return props.taxType as number;
});
const tipsInfoData = ref({
  selectedNumber: 0, //已选中订单笔数
  orderPaymentAmount: 0, //订单支付金额（分）
  accountAvailableBalance: 0, //账户可用余额（分）
  deductIndividualTaxAmount: 0, //预计扣除个税金额(分)-劳务（分）
  paidOrderAmount: 0 //  /** 预计实付订单金额-劳务（分） **/
});
const onNext = () => {
  createDialog({
    title: '支付信息确认',
    showFooter: false,
    contentRender: done => {
      return (
        <div style="padding: 20px">
          <PayInfoConfirmNext done={done} payInfo={props.payInfo} />
        </div>
      );
    }
  });
  props.done();
};

const xrkTableRef = ref<XrkTableRef>();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [orderNoSearch, projectNameSearch],
  otherComponents: []
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      indexCol,
      orderNoCol,
      projectNameCol,
      orderTimeCol,
      payPassagewayCol,
      payTypeCol,
      orderTypeCol,
      orderPriceCol,
      taxType.value === 2 && yjkcPriceCol,
      taxType.value === 2 && yjzfPriceCol
    ].filter(Boolean)
  };
});

const isLine = props.payInfo.some(item => item.payType === 1);

const getListAjax = async params => {
  const reqData = {
    ...params,
    aspOrderIdList: props.payInfo.map(item => item.aspOrderId)
  };
  const data = await confirmPageList(reqData);
  tipsInfoData.value = data.data.remark;
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, {
      tableAfter: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (taxType.value === 1)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptions), {
                key: 0,
                border: true,
                column: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseDescriptionsItem), { label: "已选中订单数量" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tipsInfoData.value.selectedNumber) + "个 ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseDescriptionsItem), { label: "订单支付金额" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.orderPaymentAmount, '元')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseDescriptionsItem), { label: "账户可用余额" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.accountAvailableBalance, '元')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (taxType.value === 2)
              ? (_openBlock(), _createBlock(_unref(BaseDescriptions), {
                  key: 1,
                  border: true,
                  column: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseDescriptionsItem), { label: "已选中订单数量" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tipsInfoData.value.selectedNumber) + "个 ", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseDescriptionsItem), { label: "预计扣除个税金额" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.deductIndividualTaxAmount, '元')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseDescriptionsItem), { label: "预计订单支付金额" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.paidOrderAmount, '元')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseDescriptionsItem), { label: "账户可用余额" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatter).fen2yuan(tipsInfoData.value.accountAvailableBalance, '元')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["searchConfig", "tableConfig"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: props.done
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        disabled: 
          !_ctx.payInfo.length ||
          (_unref(isLine) &&
            +tipsInfoData.value.accountAvailableBalance <
              +tipsInfoData.value.orderPaymentAmount)
        ,
        type: "primary",
        onClick: onNext
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 下一步 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})